import { useIntl } from 'react-intl';
import { Stack, Typography } from '@rossum/ui/material';

const NoSearchResults = () => {
  const intl = useIntl();
  return (
    <Stack
      sx={{
        py: 2,
        minHeight: 'inherit',
        textAlign: 'center',
      }}
      alignItems="center"
    >
      <Typography sx={{ fontWeight: 700 }} px={2}>
        {intl.formatMessage({
          id: 'components.labels.labelsFiltering.noSearchResults',
        })}
      </Typography>
      <Typography variant="body2" color="text.disabled" px={2}>
        {intl.formatMessage({
          id: 'components.labels.labelsFiltering.noSearchResultsDescription',
        })}
      </Typography>
    </Stack>
  );
};

export { NoSearchResults };
